import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_PUBLISH_CAMPAIGN_SERVER } from '@/app/module/campaigns/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useLaunchCampaign = () => {
  const orgId = useSelector(selectOrgId)
  const dispatch = useAppDispatch()
  const [publish, result] = esApi.endpoints.setCampaignPublished.useMutation()

  const launch = useCallback(
    async (campaignId: number | string) => {
      try {
        const res = await publish({
          orgId: orgId.toString(),
          campaignId: String(campaignId),
          body: { published: true },
        }).unwrap()
        dispatch(
          createNotification({
            'launch-campaign-success': {
              type: 'success',
              message: 'Campaign is now live.',
            },
          }),
        )
        return res
      } catch (error) {
        dispatch(
          createNotification({
            'launch-campaign-failure': {
              type: 'error',
              message: getErrorMessage(error, ERROR_PUBLISH_CAMPAIGN_SERVER),
            },
          }),
        )
        return undefined
      }
    },
    [publish, dispatch, orgId],
  )

  return [launch, result] as const
}
